import { SourceEnum } from '@chegg-wt/core/globalTypes'
import { Region } from '@chegg-wt/core/state/instrumentation/rio/clickstreamInteractions'
import React from 'react'
import { connect } from 'react-redux'
import { SourceType, JournalType } from '@chegg-wt/core/types/core'
import { clearSearchResultsError } from '@chegg-wt/core/state/errors/actions'
import SearchResultJournalError from './SearchResultJournalError'
import * as Styled from './styled'
import { SEARCH_RESULT_ERROR } from './utils/testids'

interface ErrorProps {
  sourceType: SourceType
  journalType: JournalType
  onManualCiteClick: (region: Region) => void
  onChangeJournalType: (journalType: JournalType) => void
  clearSearchResultsError: () => void
}

export const ERROR_HEADING = 'Sorry, something went wrong...'
export const ERROR_COPY =
  'Try your search again, search with different keywords or create your citation manually.'

const Error: React.FunctionComponent<ErrorProps> = ({
  sourceType,
  journalType,
  onManualCiteClick,
  onChangeJournalType,
  clearSearchResultsError,
}) => {
  if (sourceType?.id === SourceEnum.journal) {
    clearSearchResultsError()
    return (
      <SearchResultJournalError
        journalType={journalType}
        onManualCiteClick={onManualCiteClick}
        onChangeJournalType={onChangeJournalType}
      />
    )
  }

  return (
    <Styled.ErrorContainer data-test={SEARCH_RESULT_ERROR}>
      <Styled.EmptyImage />
      <Styled.LoadingDescription>
        <Styled.Heading>{ERROR_HEADING}</Styled.Heading>
        <Styled.Body>{ERROR_COPY}</Styled.Body>
      </Styled.LoadingDescription>
    </Styled.ErrorContainer>
  )
}
const mapDispatchToProps = {
  clearSearchResultsError,
}

export default connect(null, mapDispatchToProps)(Error)
